/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { useEffect, useState } from 'react';

export function useTrack(publication?: VideoProvider.ITwilioPublication) {
  const [track, setTrack] = useState(publication && publication.track);

  useEffect(() => {
    setTrack(publication && publication.track);

    if (publication) {
      const removeTrack = () => setTrack(null);

      publication.on('subscribed', setTrack);
      publication.on('unsubscribed', removeTrack);
      return () => {
        publication.off('subscribed', setTrack);
        publication.off('unsubscribed', removeTrack);
      };
    }
    return;
  }, [publication]);

  return track;
}
